t = require('views/internal/teacup-with-helpers')('header_user')

module.exports = t.renderable ({ isLoggedIn, hasCrown, showChannelPicker, escapedReturnUrl, isEnterpriseAdmin, upsellEnabled }) ->
  if isLoggedIn
    t.a '.header-btn.js-open-add-menu', { href: '#', 'aria-label': t.l('create-board-or-org') }, ->
      t.span '.header-btn-icon.icon-lg.icon-add.light'

    if upsellEnabled
      t.a '.header-btn.header-info.js-open-header-info-menu', { href: '#', 'aria-label': t.l('open-information-menu') }, ->
        t.span '.header-btn-icon.icon-lg.icon-information.light'

    t.a '.header-btn.header-notifications.js-open-header-notifications-menu', { href: '#', 'aria-label': t.l('notifications-menu') }, ->
      t.span '.header-btn-icon.icon-lg.icon-notification.light'

    if isEnterpriseAdmin
      t.a '.header-btn.header-enterprise-dashboard.js-open-enterprise-dashboard-menu', { href: '#', 'aria-label': t.l('enterprise-dashboard') }, ->
        t.span '.header-btn-icon.icon-lg.icon-enterprise-dashboard.light'

    if showChannelPicker
      t.a '.header-btn.header-btn-channel-picker.js-open-channel-picker', { href: '#', 'aria-label': t.l('switch-channels') }, ->
        t.span '.header-btn-icon.icon-lg.icon-gear.light'

    t.a '.header-btn.header-avatar.js-open-header-member-menu', { href: '#', 'aria-label': t.l('member-menu') }, ->
      t.span { class: 'member' + if hasCrown then ' has-crown' else '' }

  else
    t.a '.header-btn.header-signup', { href: '/signup' + if escapedReturnUrl then '?returnUrl=' + escapedReturnUrl else '' }, ->
      t.format 'sign-up'
    t.a '.header-btn.header-login.no-right-margin', { href: '/login' + if escapedReturnUrl then '?returnUrl=' + escapedReturnUrl else '' }, ->
      t.format 'log-in'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_user.coffee